const TEXT = {
  ENGLISH: {
    ABOUT: {
      0: "Why should you join?",
      1: "What’s Sustainathon?",
      2: `TCS Sustainathon invites you to become a driver for change by
      leveraging technology to solve real-world issues. Sustainathon
      provides a platform for the youth to collaborate with private
      companies, non-profit companies and organizations, and
      government agencies to co-create solutions in response to
      sustainability challenges.`,
    },
    BOTTOMHERO: {
      0: "Let’s get started",
      1: "Ready To make a real change?",
      2: "Events",
    },
    ERROR: {
      0: "Oops Something went wrong!",
      1: "404 - The page cannot be found",
      2: "goto Home",
      3: "Please check the URL",
      4: "We apologize for any inconvenience.",
    },
    FOOTER: {
      0: "About Us",
      1: "Tata Group",
      2: "Tata Consultancy Services",
      3: "Contact Us",
      4: "For enquiries relating to TCS Sustainathon, please email to",
      5: "Data Privacy",
      6: "Cookie Policy",
      7: "Privacy Notice",
      8: "Follow Us",
    },
    HEADER: {
      0: "Participate",
      1: "Challenges",
      2: "Webinars",
      3: "upcoming",
      4: "ongoing",
      5: "Ongoing Event",
      6: "Upcoming Event",
      7: "Launched on",
      8: "Launching SOON",
    },
    NAVBAR: {
      0: "Home",
      1: "Events",
      2: "Select Page",
    },
    STICKBAR: {
      0: "Participate",
      1: "Challenges",
      2: "Webinars",
      3: "Contact Us",
    },
    TIMER: {
      0: "Days",
      1: "Hrs",
      2: "Min",
      3: "Sec",
    },
    EVENTS: {
      0: "Upcoming Events",
      1: "Ongoing Events",
      2: "Archive Events",
      3: `Something big is on the way; come back soon to know what
        it is!`,
      4: `Something big is on the way; come back soon to know what
        it is!`,
      5: `Come back soon, we want to tell you about all that we’ve
        done!`,
      6: "No events",
      7: "Events",
      8: "Error Occured",
      9: "Events",
      10: "Ongoing",
      11: "Upcoming",
      12: "Archive",
      13: "Loading...",
      14: "Sorry Try Again Later",
    },
    EVENTDETAILS: {
      0: "Start Date:",
      1: "Location:",
      2: "Participate",
      3: "For more information, please contact",
      4: "click here",
      5: "For Terms & Conditions",
      6: "End Date:",
      7: "For FAQ's",
    },
    SUSTAINATHONS: {
      0: "Partner",
      1: "Learn More",
      2: "Close",
      3: "Click on each challenge below to learn more about it.",
      4: "No Challenges",
      5: "No judges",
      6: "Details Coming Soon...",
      7: "Join",
      8: "No Webinars",
      9: "Challenges",
      10: "Panel of Judges",
      11: "Partners",
      12: "Webinars",
    },
  },
  ARABIC: {
    ABOUT: {
      0: "لماذا يجب أن تنضم؟",
      1: "ما هو Sustainathon؟",
      2: `TCS Sustainathon 
      تدعوك لتصبح محركا للتغيير من خلال الاستفادة من التكنولوجيا لحل مشاكل العالم الحقيقة
      Sustainathon
      يوفر منصة للشباب للتعاون مع الشركات الخاصة, والشركات والمنظمات الغير ربحية ، والوكالات الحكومية لإنشاء حلول ردًا على تحديات الاستدامة`,
    },
    BOTTOMHERO: {
      0: "لنبدأ",
      1: "جاهز لإحداث تغيير حقيقي؟",
      2: "الفعاليات",
    },
    ERROR: {
      0: "عفوا حدث خطأ ما!",
      1: "404 - لا يمكن العثور على الصفحة",
      2: "الذهاب إلى الرئيسية",
      3: "يرجى التحقق من الرابط",
      4: "نعتذر عن أي إزعاج.",
    },
    FOOTER: {
      0: "حولنا",
      1: "مجموعة تاتا",
      2: "خدمات تاتا الاستشارية",
      3: "اتصل بنا",
      4: "للاستفسارات المتعلقة بـ TCS Sustainathon ، الرجاء إرسال بريد إلكتروني إلى",
      5: "خصوصية البيانات",
      6: "سياسة ملفات تعريف الارتباط",
      7: "إشعار الخصوصية",
      8: "تابعنا",
    },
    HEADER: {
      0: "شارك",
      1: "تحديات",
      2: "ندوات عبر الإنترنت",
      3: "القادم",
      4: "الحالي",
      5: "الفعالية الحالية",
      6: "الفعالية القادمة",
      7: "بدأ في",
      8: "سيبدأ قريبا",
    },
    NAVBAR: {
      0: "الرئيسية",
      1: "الفعاليات",
      2: "حدد الصفحة",
    },
    STICKBAR: {
      0: "شارك",
      1: "تحديات",
      2: "برامج الويب",
      3: "اتصل بنا",
    },
    TIMER: {
      0: "أيام",
      1: "ساعات",
      2: "دقائق",
      3: "ثواني",
    },
    EVENTS: {
      0: "الفعاليات القادمة",
      1: "الفعاليات الحالية",
      2: "أرشيف الفعاليات",
      3: `حدث كبير في الطريق ؛ عد قريبا لمعرفة ما هو`,
      4: `حدث كبير في الطريق ؛ عد قريبا لمعرفة ما هو`,
      5: `عد قريبا ، نريد أن نخبرك بكل ما قمنا بفعله`,
      6: "لا توجد فعاليات",
      7: "الفعاليات",
      8: "حدث خطأ",
      9: "الفعاليات",
      10: "الحالي",
      11: "القادم",
      12: "أرشيف",
      13: "جار التحميل...",
      14: "آسف حاول مرة أخرى في وقت لاحق",
    },
    EVENTDETAILS: {
      0: "تاريخ البدء:",
      1: "الموقع:",
      2: "شارك",
      3: "لمزيد من المعلومات، يرجى الاتصال",
      4: "انقر هنا",
      5: "للشروط والأحكام",
      6: "تاريخ الانتهاء:",
      7: "للأسئلة الشائعة",
    },
    SUSTAINATHONS: {
      0: "شريك",
      1: "تعرف أكثر",
      2: "أغلق",
      3: "انقر على كل تحدي أدناه لمعرفة المزيد عنها.",
      4: "لا توجد تحديات",
      5: "لا يوجد قضاة",
      6: "التفاصيل قريبا...",
      7: "انضم",
      8: "لا توجد ندوات عبر الإنترنت",
      9: "تحديات",
      10: "لجنة التحكيم",
      11: "شركاء",
      12: "ندوات عبر الإنترنت",
    },
  },
};

export default TEXT;
